<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">{{
                $t("sectionNovoMensagemPadrao.novaMensagemPadrao")
              }}</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>{{ $t("textObrigatorios") }}</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-3">
                  <div class="form-group">
                    <label for>* {{ $t("sectionEtapa.etapaDescricao") }}</label>
                    <input
                      v-model="viewModel.descricao"
                      class="form-control"
                      type="text"
                      :placeholder="
                        $t('sectionNovoMensagemPadrao.digiteDescricao')
                      "
                      maxlength="50"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for>* {{ $t("sectionUsuario.usuarioTexto") }}</label>
                    <b-form-textarea
                      v-model="viewModel.texto"
                      :placeholder="
                        $t('sectionNovoMensagemPadrao.digiteTextoApresentado')
                      "
                      rows="10"
                      max-rows="10"
                      required
                    ></b-form-textarea>
                  </div>
                </div>
                <div
                  class="col-sm-12 col-md-6 col-lg-6 col-xl-6"
                  :title="
                    $t(
                      'sectionNovoMensagemPadrao.tagAdicionadaTextoParametrizado'
                    )
                  "
                >
                  <label for>{{ $t("sectionNovoMensagemPadrao.tags") }}</label>
                  <div class="form-group">
                    <b-table
                      :hover="true"
                      responsive
                      :items="tags"
                      :fields="fields"
                      :perPage="porPagina"
                      :current-page="paginaCorrente"
                    >
                      <template v-slot:cell(id)="data">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="AdicionarTag(data.item.id)"
                        >
                          {{ data.item.id }}
                        </button>
                      </template>
                    </b-table>
                    <b-pagination
                      v-model="paginaCorrente"
                      :total-rows="linhas"
                      :per-page="porPagina"
                      aria-controls="my-table"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-success mr-2" type="submit">
            {{ $t("btSalvar") }}
          </button>
          <button
            class="btn btn-secondary"
            type="reset"
            @click="$router.push('/mensagem-padrao')"
          >
            {{ $t("btVoltar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "NovoMensagemPadrao",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      paginaCorrente: 1,
      porPagina: 5,
      linhas: 0,
      viewModel: {
        id: this.$store.state.emptyGuid,
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        texto: "",
        descricao: ""
      }
    };
  },
  computed: {
    tags() {
      return [
        {
          id: "[URL_CLIENTE]",
          descricao: this.$t("sectionNovoMensagemPadrao.urlCadastroCliente")
        },
        {
          id: "[NOME_CLIENTE]",
          descricao: this.$t("sectionNovoMensagemPadrao.nomeCliente")
        },
        {
          id: "[ENDERECO_CLIENTE]",
          descricao: this.$t("sectionNovoMensagemPadrao.enderecoCliente")
        },
        {
          id: "[NOME_ATENDENTE]",
          descricao: this.$t("sectionNovoMensagemPadrao.nomeAtendente")
        }
      ];
    },
    fields() {
      return [
        {
          key: "id",
          label: this.$t("sectionNovoMensagemPadrao.tag"),
          sortable: true
        },
        {
          key: "descricao",
          label: this.$t("sectionEtapa.etapaDescricao"),
          sortable: true
        }
      ];
    }
  },
  mounted() {
    this.linhas = this.tags.length;
  },
  created() {
    let id = this.$route.params.id;
    if (id) this.Obter(id);
  },
  methods: {
    AdicionarTag(tag) {
      this.viewModel.texto += " " + tag;
    },
    ValidarForm(evt) {
      evt.preventDefault();
      if (this.viewModel.id !== this.$store.state.emptyGuid) this.Editar();
      else this.Novo();
    },
    Obter(id) {
      this.loading = true;
      this.$http({
        url:
          "mensagem-padrao/obter/" +
          id +
          "/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((resposta) => {
          this.loading = false;
          this.viewModel = resposta.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Novo() {
      this.loading = true;
      this.$http({
        url: "mensagem-padrao/novo",
        data: this.viewModel,
        method: "POST"
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/mensagem-padrao");

          const padraoCadastradaComSucesso = this.$t(
            "sectionNovoMensagemPadrao.padraoCadastradaComSucesso"
          );

          this.$notify({
            data: [padraoCadastradaComSucesso],
            type: "success",
            duration: 10000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Editar() {
      this.loading = true;
      this.$http({
        url: "mensagem-padrao/editar",
        data: this.viewModel,
        method: "PUT"
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/mensagem-padrao");

          const padraoEditadaComSucesso = this.$t(
            "sectionNovoMensagemPadrao.padraoEditadaComSucesso"
          );

          this.$notify({
            data: [padraoEditadaComSucesso],
            type: "success",
            duration: 10000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>
